import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Loader2 } from "lucide-react";

type StepShellProps = {
  title: string;
  helper?: string;
  children: ReactNode;
  onBack?: () => void;
  backLabel?: string;
  onContinue?: () => void;
  continueLabel?: string;
  continueDisabled?: boolean;
  saving?: boolean;
  footer?: ReactNode;
};

export function StepShell({
  title,
  helper,
  children,
  onBack,
  backLabel = "Back",
  onContinue,
  continueLabel = "Continue",
  continueDisabled,
  saving,
  footer,
}: StepShellProps) {
  return (
    <Card className="border-border/70">
      <CardHeader className="pb-3">
        <CardTitle className="text-xl sm:text-2xl">{title}</CardTitle>
        {helper ? <CardDescription className="text-sm">{helper}</CardDescription> : null}
      </CardHeader>
      <CardContent className="space-y-5">
        {children}
        {footer}
        {(onBack || onContinue) && (
          <div className="flex items-center justify-between gap-3 pt-2">
            {onBack ? (
              <Button type="button" variant="ghost" onClick={onBack} className="min-h-11">
                <ArrowLeft className="mr-2 h-4 w-4" />
                {backLabel}
              </Button>
            ) : (
              <span />
            )}
            {onContinue ? (
              <Button
                type="button"
                onClick={onContinue}
                disabled={continueDisabled || saving}
                className="min-h-11 flex-1 sm:flex-none sm:min-w-40"
              >
                {saving ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Saving
                  </>
                ) : (
                  continueLabel
                )}
              </Button>
            ) : null}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
